var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dropdown-wrapper",
    class: {
      open: _vm.open
    }
  }, [_c('button', {
    staticClass: "dropdown-title",
    attrs: {
      "type": "button",
      "aria-label": _vm.dropdownAriaLabel
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm.item.link ? _c('router-link', {
    staticClass: "link-title",
    attrs: {
      "to": _vm.item.link
    }
  }, [_vm._v(_vm._s(_vm.item.text))]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.item.link,
      expression: "!item.link"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.item.text))]), _vm._v(" "), _c('span', {
    staticClass: "arrow",
    class: _vm.open ? 'down' : 'right'
  })], 1), _vm._v(" "), _c('DropdownTransition', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.open,
      expression: "open"
    }],
    staticClass: "nav-dropdown"
  }, _vm._l(_vm.item.items, function (subItem, index) {
    return _c('li', {
      key: subItem.link || index,
      staticClass: "dropdown-item"
    }, [subItem.type === 'links' ? _c('h4', [_vm._v(_vm._s(subItem.text))]) : _vm._e(), _vm._v(" "), subItem.type === 'links' ? _c('ul', {
      staticClass: "dropdown-subitem-wrapper"
    }, _vm._l(subItem.items, function (childSubItem) {
      return _c('li', {
        key: childSubItem.link,
        staticClass: "dropdown-subitem"
      }, [_c('NavLink', {
        attrs: {
          "item": childSubItem
        },
        on: {
          "focusout": function ($event) {
            _vm.isLastItemOfArray(childSubItem, subItem.items) && _vm.isLastItemOfArray(subItem, _vm.item.items) && _vm.toggle();
          }
        }
      })], 1);
    }), 0) : _c('NavLink', {
      attrs: {
        "item": subItem
      },
      on: {
        "focusout": function ($event) {
          _vm.isLastItemOfArray(subItem, _vm.item.items) && _vm.toggle();
        }
      }
    })], 1);
  }), 0)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };